export default __webpack_public_path__ + "static/media/photo03_pc.4d01262b.jpg";